export default __webpack_public_path__ + "static/media/four-dots.52a65301.less";